
import {
  RevIllustration,
  RevModal,
  RevSpinner,
} from '@backmarket/design-system'

import ContentRow from '../../ContentRow'

import translations from './ContentRowModal.translations'

export default {
  components: {
    ContentRow,
    RevIllustration,
    RevModal,
    RevSpinner,
  },
  props: {
    hasError: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    modalName: {
      type: String,
      default: '',
    },
    modalTitle: {
      type: String,
      default: '',
    },
    onModalClose: {
      type: Function,
      default: () => {},
    },
    onModalOpen: {
      type: Function,
      default: () => {},
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    translations: () => translations,

    shouldDisplayContent() {
      return !this.hasError && !this.isLoading
    },
  },
}
